/** @jsxFrag React.Fragment */

/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Skeleton, Typography, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/account-profile';

const styles = {
  section: () => css`
    margin-bottom: var(--cds-spacing-200);
  `,
};

export const WorkEligibilitySkeletonLoader = () => {
  return (
    <div role="status">
      <Typography variant="h2semibold" data-testid="work-eligibility-section-loaader" css={styles.section}>
        {_t('Work eligibility')}
      </Typography>
      <Typography2 component="p" css={styles.section}>
        <Skeleton />
        <Skeleton />
        <Skeleton />
      </Typography2>
    </div>
  );
};

export default WorkEligibilitySkeletonLoader;
